<template lang="pug">
.funnel-settings-fields
  BriqInput(
    label="Homepage url"
    name="EmailCompanyUrl"
    v-model="settings.EmailCompanyUrl" 
    :disabled="isSaving" 
    )
  BriqInput(
    label="Browser tagline"
    name="Tagline"
    v-model="settings.Tagline" 
    :disabled="isSaving"
    help="The tagline is shown in title"
    )
  .briq-form-element
    label Phone number
    p 
      | You can set the phone number on the 
      a(href="/settings/application/contacts") Contacts
      |  page.
  BriqMultiselect(
    v-if="displayAdvanced"
    name="BrandingLogoUrl"
    label="Powered by Logo"
    help="Set the Powered by Logo"
    :options="poweredByOptions"
    track-by="value"
    display="name"
    v-model="settings.BrandingLogoUrl"
    :disabled="isSaving"
    required
    )
  BriqInput(
    label="Newsletter policy url"
    name="MerchantPrivacyPolicy"
    help="If you fill in this field an optional newsletter opt-in will be placed in the funnel."
    v-model="settings.MerchantPrivacyPolicy" 
    :disabled="isSaving" 
    )
  BriqInput(
    label="Terms & Conditions URL"
    name="EmailTermsAndConditionsUrl"
    help="URL to the terms & conditions, so it can be added to the e-mails and confirmation page."
    v-model="settings.EmailTermsAndConditionsUrl" 
    :disabled="isSaving" 
    )
  BriqTextarea(
    label="Unique selling points"
    name="Usps"
    :rows="6"
    :max-lines="6"
    help="What makes your venue a unique experience for visitors? Put each on a new line, max. 6."
    v-model="settings.Usps" 
    :maxlength="1000"
    placeholder="usp 1\nusp 2\nusp 3\nusp 4\nusp 5 \nusp 6"
    with-character-counter
    )
  BriqInput(
    type="number"
    step="0.5"
    min="0"
    max="5"
    label="Facebook rating"
    name="FacebookRating"
    help="Choose value between 0.5 and 5 to show on deal-page."
    v-model="settings.FacebookRating" 
    :disabled="isSaving" 
    :error="facebookRatingError"
    )
  BriqInput(
    type="number"
    step="0.5"
    min="0"
    max="5"
    label="Tripadvisor rating"
    name="TripadvisorRating"
    help="Choose value between 0.5 and 5 to show on deal-page."
    v-model="settings.TripadvisorRating" 
    :disabled="isSaving"
    :error="tripadvisorRatingError"
    )
  .briq-form-element
    label E-mail
    p 
      | You can set the e-mail address on the 
      a(href="/settings/application/contacts") Contacts
      |  page.
  BriqInput(
    label="Google Tag Manager ID (starts with GTM-)"
    name="TagManagerId"
    v-if="displayAdvanced"
    v-model="settings.TagManagerId" 
    :disabled="isSaving" 
    )
  BriqInput(
    label="Facebook Domain Verification Id"
    name="FacebookDomainVerificationId"
    v-if="displayAdvanced"
    v-model="settings.FacebookDomainVerificationId" 
    :disabled="isSaving" 
    )
</template>

<script>
import ImagePicker from '@v/components/ImagePicker.vue'

export default {
  name: 'FunnelSettingsFields',
  components: { ImagePicker },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    displayAdvanced: Boolean,
    isSaving: Boolean,
    validations: Object,
  },
  data() {
    return {
      poweredByOptions: [
        {
          name: 'BRIQ Bookings',
          value: '/images/logo_powered-by-briqbookings.svg',
        },
        {
          name: 'Clubspeed + BRIQ Bookings',
          value: '/images/logo_powered-by-clubspeed-briqbookings.svg',
        },
      ],
    }
  },
  computed: {
    tripadvisorRatingError() {
      const error =
        this.validations?.$dirty &&
        this.validations.settings.TripadvisorRating.$invalid &&
        'Tripadvisor rating must be a number between 0 and 5'
      return error || null
    },
    facebookRatingError() {
      const error =
        this.validations?.$dirty &&
        this.validations.settings.FacebookRating.$invalid &&
        'Facebook rating must be a number between 0 and 5'
      return error || null
    },
  },
}
</script>

<style lang="stylus">
.funnel-settings-fields .briq-form-element
  margin-bottom 24px
</style>
